import { Goal, ID, Task } from '@griply/types';

const isTaskScheduled = (task: Task): boolean =>
  !!(
    task.schedules?.length ||
    task.endStrategy?.deadline ||
    task.deadlineDeadline
  );

// Dropping a completed goal's unscheduled tasks removes its group header from the list.
export const dropTasksOfCompletedGoalsWithoutScheduledTasks = (
  tasks: Task[],
  goals: Goal[],
): Task[] => {
  const completedGoalIds = new Set(
    goals.reduce<ID[]>((acc, { id, completedAt }) => {
      if (completedAt) {
        acc.push(id);
      }
      return acc;
    }, []),
  );

  if (!completedGoalIds.size) {
    return tasks;
  }

  const completedGoalsWithScheduledTask = new Set<ID>();
  tasks.forEach((task) => {
    if (
      task.goalId &&
      completedGoalIds.has(task.goalId) &&
      isTaskScheduled(task)
    ) {
      completedGoalsWithScheduledTask.add(task.goalId);
    }
  });

  return tasks.filter((task) => {
    if (!task.goalId || !completedGoalIds.has(task.goalId)) {
      return true;
    }
    return completedGoalsWithScheduledTask.has(task.goalId);
  });
};
